import { render, staticRenderFns } from "./AllowedGroups.vue?vue&type=template&id=f16674a2&scoped=true"
import script from "./AllowedGroups.vue?vue&type=script&lang=js"
export * from "./AllowedGroups.vue?vue&type=script&lang=js"
import style0 from "./AllowedGroups.vue?vue&type=style&index=0&id=f16674a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16674a2",
  null
  
)

export default component.exports